<template>
  <div class="w-100 no-gap">
    <Slide />
    <InfoSchool v-if="infoOpen" :key="infoOpen" />
    <cardUser/>
  </div>
</template>
<script>
import Slide      from "@/projects/views/slide/components/slide.vue"
import cardUser   from "@/projects/views/slide/components/cardUser.vue"
import InfoSchool from "@/projects/views/vote_Info/components/Info_School.vue"
import api        from "@/service/api.js"
import moment     from "moment-timezone"

export default {
  name: "Home",
  components: { Slide, cardUser, InfoSchool },

  data() {
    return {
      setters: [],
      events: []
    }
  },

  async created() {
    console.log("[Home] mounted, fetching setters and events…")
    try {
      const [settersRes, eventsRes] = await Promise.all([
        api.setter("get"),
        api.event("get")
      ])

      this.events = eventsRes.data.data || []

      this.setters = (settersRes.data.data || []).map(s => {
        const eventName =
            typeof s.title === "string"
                ? this.events.find(e => e._id === s.title)?.event_name || ""
                : s.title?.event_name || ""

        return {
          eventName,
          startDate: s.startDate,
          endDate:   s.endDate
        }
      })

      console.log("[Home] fetched setters:", this.setters)
    } catch (err) {
      console.error("[Home] failed to fetch setters or events:", err)
    }
  },

  computed: {
    infoOpen() {
      const now = moment().tz("Asia/Bangkok")
      const open = this.setters.some(w =>
          w.eventName === "Information" &&
          now.isBetween(moment(w.startDate), moment(w.endDate), null, "[]")
      )
      console.log("[Home] infoOpen?", open)
      return open
    }
  }
}
</script>
